module.exports = __webpack_public_path__ + "img/FDA.d8b595fd.jpg";